module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAE5SURBVHgBrZGxTsNADIbP1wulYuERMkKm7FBE3qB9goYRggR5AsIThIXM6RPQPkEyUBjJAq3EQHiDTFAl5IwvNAihNupQS9b95/tsnW1gDbbnR3pL03plUYxmrpWqGDTBvK1FJHXyrECwXp2DBJpgJI1QWFC2POB8IFnLhqbK9HjzfHboqrgRTO4o/RhWVQbEMQO4IPfYPB/Dlogkh4Sv+saL071kiNfkXgUDpJ/bRZ8vg2enPxNh+ddIHRXcKaz0xMrA9KPdvK09EZwR3K9hw4/M38oLWMX5XAhTNYglujW8Hzz0FnDyF1YmagGdnbfqe8HjAFgZSsTh1Ona/6coAMCsEvKP2AjuSZU6Sjmcnh/ZbImphJj2HVY3Kd+p7ZTgkG3KwLid2LSlqzX5TEiex1wKfR1aMp5+A8ZPmuuS/EAVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/pencil.png
// module id = 8ygp
// module chunks = 3